import { render, staticRenderFns } from "./SummaryLearning.vue?vue&type=template&id=a7ed80ae&"
import script from "./SummaryLearning.vue?vue&type=script&lang=js&"
export * from "./SummaryLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports